import { Box, Typography, useTheme } from "@mui/material";
import React, { forwardRef } from "react"; 
import "./selectcomponent.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useSelector } from "react-redux";

const SelectComponent = forwardRef(({ label, value, onClick,disabled,isIcon=false,borderColor='#fff',ishotel,validationSchema,height= "70px",icon=true }, ref) => {
  const theme =useTheme()
  const {
    css
  }=useSelector((store)=> store?.widgetSettings);
  const overallCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Overall"
  )?.fields
  const hasError = Boolean(validationSchema);
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        minWidth: "100px",
        width: "100%",
        height: height,
        border: `1px solid ${
          hasError
            ? (theme?.widget?.error ?? 'red')
            : overallCss?.selectComponentBorderClr
        }`,
        backgroundColor: overallCss?.selectComponentBg ?? "#fff",
        borderRadius: "3px",
        cursor:'pointer',
      }}
      onClick={() => {
        if (disabled) return; // Prevent click action if disabled
        onClick();
      }}
      ref={ref} // Attach the ref here
     
    >
   <Box sx={{display:'flex',alignItems:'center'}}>
    {ishotel && <Box sx={{ml:1}}>
      <CalendarMonthIcon sx={{color:"#F37120"}} />
    </Box>}
      <Box>
        <Typography
          sx={{ fontSize: "12px", color: overallCss?.selectComponentTxtClr, ml: 2, fontWeight: "200" }}
        >
          {label}
        </Typography>
        <Typography sx={{ fontSize: "16px", color:  overallCss?.selectComponentTxtClr, ml: 2 }}>
          {value}
        </Typography>
      </Box>
      </Box>
      <Box>
        {
          isIcon ? <CalendarMonthIcon sx={{mr:1}}/> : icon &&   <KeyboardArrowDownIcon sx={{ color: overallCss?.selectComponentIconClr, mr: 2 }} />
        }
       
      </Box>
    </Box>
  );
});

export default SelectComponent;
